import {
  IExhibitorPair,
  IExhibitorUserConnection,
  INotificationBaseRelatedToShow,
  IPayloadUpdatedExhibitorPair,
  NotificationType,
} from "@evennt-tech/api-v2-core";

import {useEffect} from "react";
import {shallow} from "zustand/shallow";
import {apiV2} from "api/firebase";
import {useCurrentExhibitor} from "store/current-exhibitor/current-exhibitor.store";

export type UseCurrentExhibitorPairParams = {
  showId: string;
  exhibitorPairId: string;
};

export type UseCurrentExhibitorPairRes = [
  IExhibitorPair | null,
  IExhibitorUserConnection | null,
  boolean
];

export default ({
  exhibitorPairId,
  showId,
}: UseCurrentExhibitorPairParams): UseCurrentExhibitorPairRes => {
  const {fetch} = useCurrentExhibitor();

  const {connection, pair} = useCurrentExhibitor(
    (state) => state.getExhibitorPair(showId, exhibitorPairId),
    shallow
  );
  const isLoading = useCurrentExhibitor((state) => state.isLoading, shallow);

  useEffect(() => {
    fetch();
  }, [showId]);

  useEffect(() => {
    const listenerId = "UPDATED_EXHIBITOR_PAIR_FROM_USE_CURRENT_EXHIBITOR_PAIR";

    apiV2.notification.subscribe<
      INotificationBaseRelatedToShow<IPayloadUpdatedExhibitorPair>
    >({
      key: NotificationType.UPDATED_EXHIBITOR_PAIR,
      showId,
      listenerId,
      callback: async ({showId: eventShowId, payload}) => {
        if (eventShowId !== showId) {
          return;
        }
        if (payload && payload.exhibitorPairId !== exhibitorPairId) {
          return;
        }
        await fetch(true);
      },
    });

    return () => {
      apiV2.notification.unsubscribe({
        key: NotificationType.UPDATED_EXHIBITOR_PAIR,
        showId,
        listenerId,
      });
    };
  }, [showId, exhibitorPairId, fetch]);

  return [pair, connection, isLoading];
};
